import { ASTWithName } from '@angular/compiler';
import { Injectable } from '@angular/core';
// import { throwMatDialogContentAlreadyAttachedError } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CognitoUser, CognitoUserPool, CognitoUserSession } from 'amazon-cognito-identity-js';
import { BehaviorSubject, Observable, observable, of } from 'rxjs';
import { tryCatch } from 'rxjs/internal-compatibility';
import { delay, timeInterval } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';
import { environment } from '../../environments/environment';
import { callbackify } from 'util';
import { confirmResetPassword, confirmSignIn, fetchUserAttributes, getCurrentUser, resetPassword, signIn } from 'aws-amplify/auth';

@Injectable({
  providedIn: 'root'
})
export class AuthNewService {
  user = new Subject<CognitoUser>();
  currentUser!: CognitoUser;
  passwordChanged = new BehaviorSubject<boolean>(false);
  forgotPasswordCode = new BehaviorSubject<boolean>(false);
  forgotPasswordMessage = new BehaviorSubject<string>('');
  userGroup = new BehaviorSubject('');
  groups;
  forgotMessage;
  signinError = new BehaviorSubject<string>('');
  getCurrentLoginUser = new Subject<CognitoUser>();
  private userPool = new CognitoUserPool(environment.userPool);

  constructor(private router: Router) {
    
  }


  // function to signin
  async handleSignIn(username: string, password: string) {
    try {
      const { isSignedIn, nextStep } = await signIn({username, password});
      if (
        nextStep.signInStep === "CONFIRM_SIGN_IN_WITH_EMAIL_CODE" ||
        nextStep.signInStep === "CONFIRM_SIGN_IN_WITH_SMS_CODE" ||
        nextStep.signInStep === "CONFIRM_SIGN_IN_WITH_TOTP_CODE"
      ) {
        return {Status: "MFA"};
      } else if ( nextStep.signInStep === "CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED" ) {
        return {Status: "NEW_PASSWORD"};
      } else {
        if ( isSignedIn ) {
          const userAttributes = await fetchUserAttributes();
          sessionStorage.setItem('access', userAttributes['custom:access']);
          return {Status: "SUCCESS"};
        } else {
          console.log("Unhandled case from signin call:");
          console.log(nextStep.signInStep);
          return {Status: "UNHANDLED"};
        }
      }
//       this.currentUser = userId;
//       this.user.next(userId);
    } catch (error) {
      this.signinError.next(error);
      return {Status: "ERROR"};
    }
//     Auth.signIn(username, password)
//     .then((user: any) => {
//       // console.log('user print in service', user)
//       this.currentUser = user;
//       this.user.next(user);
//       if (user.attributes !== undefined) {
//         sessionStorage.setItem('access', user['attributes']['custom:access']);
//       }
//     })
//     .catch((error) => {

      // console.log('Error occured while signin', error);
//     })

  }

  async handleConfirmCode(code:string) {
    // console.log(this.currentUser);
    try {
      const { isSignedIn, nextStep } = await confirmSignIn({challengeResponse: code});
      return { isSignedIn, nextStep };
    } catch (error) {
      return { isSignedIn:false, nextStep:"Error"};
    }
//     .then((data: any) => {
//       if (data.isSignedIn) {
//
//       }
//       this.user.next(data);
//     })
//     .catch((error) => {
//       // console.log(error);
//     })
  }

  async getGroups() {
    try {
      const userAttributes = fetchUserAttributes();
      console.log(userAttributes);
      this.userGroup.next(userAttributes['cognito:groups']);
    } catch (error) {
      console.log(error);
    }
  }

//   // function to handle new password
  async newPassword(newPassword:string) {
    try {
      await confirmSignIn({challengeResponse:newPassword});
      this.passwordChanged.next(true);
    } catch(error) {
      console.log(error);
    }
  }

  // function to get the current user
//   getCurrentUser(User?) {
//     Auth.currentAuthenticatedUser({
//       bypassCache: true
//     }).then(user => {
//       this.getCurrentLoginUser.next(user);
//     })
//     .catch(err => {
//       return err
//     });
//     }

  // function to signout
//   signout () {
//     Auth.currentAuthenticatedUser({
//       bypassCache: true
//     })
//     .then(user => {
//       if (user) {
//         try {
//           this.user.next(null);
//           Auth.signOut({global: true})
//         } catch (error) {
//           console.log('error occured while logout', error);
//         }
//         this.router.navigate(['']);
//       }
//     })
//     .catch(err => console.log(err));
//   }

  // function to handle forget password
  // Send confirmation code to user's email
  async forgetPassword(username:string) {
    try {
      const result = await resetPassword({username});
      console.log(result);
      this.forgotPasswordCode.next(true);
    } catch(error) {
      console.log(error);
    }
  }

  // Collect confirmation code and new password, then
  async forgetPasswordConfirm(username, code, password) {
    try {
      await confirmResetPassword({username: username, newPassword: password, confirmationCode: code});
      this.forgotMessage = 'Password Changed';
    } catch(error) {
      console.log(error);
      this.forgotMessage = 'Error';
    }
    setTimeout(() => {
      this.forgotPasswordMessage.next(this.forgotMessage);
    }, 2000);

  }

  async getAuthenticatedUser() {
    const user = await getCurrentUser();
    return user;
  }

}
